import { Field } from "formik";
import React, { useEffect, useState } from 'react';
import Input from 'react-phone-number-input/input'

export const MultiField = ({
    setFieldValue,
    name,
    type,
    values,
    dashOnEmpty,
    emptyIsNull = true,
    onChange,
    onFocus,
    onBlur,
    ...props
}) => {

    const getValue = (key = name) => {
        return key.split('.').reduce((a, b) => a[b], values);
    }

    const didChange = () => {
        return !(
            getValue() === value ||
            (
                getValue() === null &&
                (
                    (value === '—' && dashOnEmpty) ||
                    value === ''
                )
            )
        );
    }

    const change = (e) => {
        setValue(e.target.value);
        if (onChange) onChange(e);
    }

    const telChange = (e) => {
        setValue(e);
        if (onChange) onChange(e);
    }

    const focus = (e) => {
        if (value === '—' && dashOnEmpty)
            setValue('');
        if (onFocus) onFocus(e);
    }

    const blur = (e) => {
        if (getValue() === null && dashOnEmpty)
            setValue('—');
        if (onBlur) onBlur(e);
    }


    const [value, setValue] = useState(getValue() ?? (dashOnEmpty && type !== 'tel' ? '—' : ''));

    useEffect(() => {
        if (didChange())
            setValue(getValue() ?? '');
    }, [values]);

    useEffect(() => {
        if (didChange())
            setFieldValue(name, (value === '' && emptyIsNull) ? null : value);
    }, [value]);


    return type === 'tel' ?
        <Input
            value={value}
            defaultCountry='US'
            onChange={telChange}
            onFocus={focus}
            onBlur={blur}
            {...props}
        />
        : <Field
            type={type}
            value={value}
            onChange={change}
            onFocus={focus}
            onBlur={blur}
            {...props}
        />
}